// extracted by mini-css-extract-plugin
export default {"list":"_e0b68f3b"};